import { Box, Text, Badge, Spinner } from '@radix-ui/themes';

import { useAudiencePreviewSize } from '../../hooks/useAudiencePreviewSize';
import styles from './AudienceForm.module.css';

const SegmentBadge = ({ label }) => (
  <Badge variant="soft" color="blue">
    {label}
  </Badge>
);

const SegmentSeparator = ({ isLast, isSecondToLast }) => {
  if (isSecondToLast) {
    return <Text weight="bold"> OR </Text>;
  }
  if (!isLast) {
    return ', ';
  }
  return null;
};

const SegmentGroupPreview = ({ segments }) => (
  <>
    (
    {segments.map((segment, index) => (
      <span key={segment.value}>
        <SegmentBadge label={segment.label} />
        <SegmentSeparator
          isLast={index === segments.length - 1}
          isSecondToLast={index === segments.length - 2}
        />
      </span>
    ))}
    )
  </>
);

export const AudiencePreview = ({ segmentGroups }) => {
  const {
    audienceSize,
    isLoading,
    groupsWithSegments,
  } = useAudiencePreviewSize(segmentGroups);

  if (groupsWithSegments.length === 0) {
    return null;
  }

  return (
    <Box className={styles.previewBox}>
      <Box>
        <Text size="2" weight="bold" mr="1">
          Current Audience Size:
        </Text>
        <Text size="2">
          {isLoading ? (
            <Spinner size="1" />
          ) : (
            audienceSize?.toLocaleString() ?? '—'
          )}
        </Text>
      </Box>

      <Text size="2">
        This audience includes users tagged with{' '}
        {groupsWithSegments.map((group, index) => (
          <span key={group.id}>
            {index > 0 && <Text weight="bold"> AND </Text>}
            <SegmentGroupPreview segments={group.segments} />
          </span>
        ))}
      </Text>
    </Box>
  );
};
